/**
 * Возвращает картинки, которые лежат внутри узлов `lightbox-gallery`
 * @param tree
 */
export function getLightBoxImages(tree: TContent): TContent[] {
  const result: TContent[] = [];

  const fillResult = (node: TContent): void => {
    const isLightBoxItem = node.attributes?.['data-rel']?.indexOf('lightbox-gallery') === 0;
    if (isLightBoxItem) {
      const images = getImageFromNode(node);
      result.push(...images);
    } else {
      node.children.forEach((child: TContent) => fillResult(child));
    }
  };

  fillResult(tree);

  return result;
}

function getImageFromNode(node: TContent): Array<TContent> {
  const images: Array<TContent> = [];

  node.children.forEach((child) => {
    if (child.type === 'img') {
      images.push(child);
    } else {
      getImageFromNode(child);
    }
  });

  return images;
}
